import { SerializableObject } from '../../../legacy/objects/generic/serialization/serializable-object';
import { SessionURL } from '../../core/session-url/session-url';

import { ExperienceTriggerConstructor } from './experience-trigger-constructor';
import { ExperienceTriggerEnableIf } from './experience-trigger-enable-if';
import { ExperienceTriggerSchema } from './experience-trigger-schema';

export class ExperienceTrigger extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected firstClick?: SessionURL;
  protected enableIf!: ExperienceTriggerEnableIf;
  protected keywords?: string[];
  /////////////////////////////////////////////////////////////////////////////
  // Get Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): ExperienceTriggerSchema {
    return new ExperienceTriggerSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(input: ExperienceTriggerConstructor) {
    super(input);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(ExperienceTrigger.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): ExperienceTrigger {
    return new ExperienceTrigger(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getFirstClick() {
    return this.firstClick;
  }

  public getEnableIf() {
    return this.enableIf;
  }

  public getKeywords() {
    return this.keywords;
  }
}
